import React from 'react';
import { Text as RNText, TextProps as RNTextProps } from 'react-native';
import s, { getFontFamily } from './Typography.styles';

export type HeadlineProps = RNTextProps & {
  weight?: 'regular' | 'medium' | 'semibold';
};

export const Headline: React.FC<HeadlineProps> = ({
  children,
  weight = 'regular',
  style,
  ...props
}) => {
  return (
    <RNText style={[s.common, s.headline, getFontFamily(weight), style]} {...props}>
      {children}
    </RNText>
  );
};
